// extracted by mini-css-extract-plugin
export default {"root":"RequestLinks_root__FfWhk","link":"RequestLinks_link__XN1bD","counter":"RequestLinks_counter__g+Fum"};